"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _useOurTranslation = _interopRequireDefault(require("../../utils/useOurTranslation"));

var _jsxRuntime = require("react/jsx-runtime");

var PhoneHint = function PhoneHint() {
  var t = (0, _useOurTranslation.default)("profile-components:PhoneHint");
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
    children: [t("text"), " ", /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), /*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
      style: {
        color: 'red'
      },
      children: t("attention")
    }), t("text2"), /*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
      children: t("code1")
    }), t("textCode1"), /*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
      children: t("code2")
    }), t("textCode2"), /*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
      children: t("code3")
    }), t("textCode3")]
  });
};

var _default = PhoneHint;
exports.default = _default;